import { List, Datagrid, TextField, NumberField, FilterLiveSearch, Filter, TopToolbar, CreateButton, useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';

const ProductThumb = () => {
    const record = useRecordContext();
    if (!record || !record.article) return null;
    return (
        <img src={`/product/image/${record.article}/0`}
            style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 4, background: '#fff' }}
            alt={record.article} />
    );
};

const StockField = () => {
    const record = useRecordContext();
    if (!record) return null;
    const color = record.count === 0 ? '#e01a76' : record.count < 3 ? '#e65100' : '#2e7d32';
    return <span style={{ color, fontWeight: 600, fontSize: 15 }}>{record.count}</span>;
};

const ProductFilter = () => (
    <Filter>
        <FilterLiveSearch source="name" />
    </Filter>
);

const ProductListActions = () => (
    <TopToolbar>
        <CreateButton />
    </TopToolbar>
);

const ProductList = () => (
    <List perPage={25} filters={<ProductFilter />} actions={<ProductListActions />}
        sort={{ field: 'id', order: 'ASC' }}>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
            <ProductThumb source="article" label="Фото" sortable={false} />
            <TextField source="article" label="Артикул" />
            <TextField source="name" label="Название" />
            <TextField source="type" label="Тип" />
            <TextField source="collection" label="Коллекция" />
            <NumberField source="price" label="Цена" sortBy="price" options={{ style: 'currency', currency: 'RUB', minimumFractionDigits: 0 }} />
            <StockField source="count" label="Остаток" />
        </Datagrid>
    </List>
);

export default ProductList;
